import useI18n from '@/hooks/useI18n';
import { PlusOutlined } from '@ant-design/icons';
import { Input, Modal, Space } from 'antd';
import React, { useState } from 'react';
import styles from './index.less';

export interface DepartmentProps {
  title?: string;
  value?: any;
  width?: number | string;
  children: any;
  isDisable?: boolean;
  isReadOnly?: boolean;
  inputPlaceHolder?: string;
  onOperator?: () => void;
  onOk?: (callback: () => void) => void;
  onClose?: (callback: () => void) => void;
}

const PopEdit: React.FC<DepartmentProps> = ({
  title,
  width,
  children,
  value,
  isReadOnly = true,
  isDisable = false,
  inputPlaceHolder,
  onOperator,
  onOk,
  onClose,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const { formatMessage } = useI18n();
  return (
    <div className={styles.popEditWrap}>
      <Input
        readOnly={isReadOnly} // 兼容某些场景可手动清空value (比如：order模块操作项)
        disabled={isDisable}
        value={value}
        allowClear
        placeholder={inputPlaceHolder}
        addonAfter={
          <Space
            className={styles.addIcon}
            // onClick={() => (!isDisable ? setOpen?.(true) : null)}
            onClick={() => {
              if (!isDisable) {
                setOpen?.(true);
              }
              onOperator?.();
            }}
          >
            <PlusOutlined />
          </Space>
        }
        onChange={() => {
          onOperator?.();
        }}
        onBlur={() => {
          onOperator?.();
        }}
      />
      <Modal
        title={title}
        open={open}
        centered
        width={width}
        styles={{ body: { minHeight: 500, maxHeight: 'calc(100vh - 120px)', overflowY: 'auto' } }}
        onOk={() => {
          onOk?.(() => setOpen(false));
        }}
        onCancel={() => {
          onClose?.(() => setOpen(false));
        }}
        okText={formatMessage('common.OK')}
        cancelText={formatMessage('common.cancel')}
      >
        {children}
      </Modal>
    </div>
  );
};

export default PopEdit;
